// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var designRouter = {
  path: '/design',
  component: Layout,
  redirect: '/design/devise',
  name: 'design',
  meta: {
    title: '装修',
    icon: 'clipboard'
  },
  children: [{
    path: 'theme',
    name: 'theme',
    component: function component() {
      return import('@/views/design/theme/index');
    },
    meta: {
      title: '一键换色'
    }
  }, {
    path: 'viewDesign',
    name: 'viewDesign',
    component: function component() {
      return import('@/views/design/viewDesign/index');
    },
    meta: {
      title: '页面设计'
    }
  }, {
    path: 'devise',
    name: 'devise',
    component: function component() {
      return import('@/views/design/devise/index');
    },
    meta: {
      title: '首页装修'
    }
  }, {
    path: 'advertisement',
    name: 'advertisement',
    component: function component() {
      return import('@/views/design/advertisement/index');
    },
    meta: {
      title: '开屏广告'
    }
  }]
};
export default designRouter;